export default __webpack_public_path__ + "static/media/business-problem1-sc.e5db3d50.png";